import { render, staticRenderFns } from "./thrombophiliaAlgorithm.vue?vue&type=template&id=c1a8f424&scoped=true"
import script from "./thrombophiliaAlgorithm.vue?vue&type=script&lang=js"
export * from "./thrombophiliaAlgorithm.vue?vue&type=script&lang=js"
import style0 from "./thrombophiliaAlgorithm.vue?vue&type=style&index=0&id=c1a8f424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a8f424",
  null
  
)

export default component.exports